import { multicastChannel } from 'redux-saga';
import ddt from '@wix/da-ddt';
import { CompliantCategories, LocalStorageCategoryTypeConfig, } from './constants';
export var verifyAccessToLocalStorage = function (key, privacyRequired, hasAcceptedCookies, acceptedCookieTypes) {
    var cookieType = LocalStorageCategoryTypeConfig[key];
    if (!cookieType) {
        ddt.error('compliantlocalstorage', "Attempted to access unregistered localStorage key: ".concat(key));
        return false;
    }
    // allow access if user is not in a region where privacy compliancy is required
    if (!privacyRequired) {
        ddt.log('compliantlocalstorage', "allowed access to: ".concat(key, " because cookie privacy is not required in this region"));
        return true;
    }
    // allow all ESSENTIAL COOKIES
    if (cookieType === CompliantCategories.ESSENTIAL) {
        ddt.log('compliantlocalstorage', "allowed access to: ".concat(key, " because it is an ESSENTIAL cookie"));
        return true;
    }
    // only CompliantCategories.ESSENTIAL is allowed if user has not accepted cookies
    if (!hasAcceptedCookies) {
        ddt.log('compliantlocalstorage', "denying access to: ".concat(key, " because user has not accepted cookies"));
        return false;
    }
    if (acceptedCookieTypes[cookieType] === true) {
        ddt.log('compliantlocalstorage', "allowed access to: ".concat(key, " because user has accepted ").concat(cookieType, " cookies"));
        return true;
    }
    ddt.log('compliantlocalstorage', "key: ".concat(key, " is not a cookie type user has accepted"));
    return false;
};
// Storage event channel singleton: the initial self-call generates a
// channel, sunsequent calls to `getStorageEventChannel` fetch it
export var getStorageEventChannel = (function () {
    var channel = multicastChannel();
    return function () { return channel; };
})();
//# sourceMappingURL=utils.js.map